/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { get, set, del } from 'idb-keyval';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

export const CACHE_KEY = 'corex-rq-cache';

export const idbPersister = createAsyncStoragePersister({
  key: CACHE_KEY,
  throttleTime: 1000,
  storage: {
    // A rejected get() is intentionally left to propagate: persistQueryClientRestore swallows the
    // error and simply discards the cache, so no extra handling is needed here.
    getItem: async (key: string) => (await get(key)) ?? null,
    setItem: (key: string, value: string) => set(key, value),
    removeItem: (key: string) => del(key),
  },
});

/** Wipes the persisted query cache (call on login and logout to prevent cross-user leakage). */
export async function clearPersistedQueryCache(): Promise<void> {
  await del(CACHE_KEY);
}
